<div class="flex p-4 h-full">
  <div id="category-list" class="flex flex-col h-full flex-1"  [class.hide]="selectedCategory() != undefined">
    <div class="text-2xl font-bold mb-4">{{ 'gallery.categories' | translate }}</div>

    <div class="flex flex-col h-full overflow-auto">
      @defer (hydrate on viewport) {
        @if (categories.isLoading()) {
          <p-skeleton height="4.5rem" />
        } @else {
          @if (categories.error()) {
            <span class="text-xl italic text-orange-500">
              {{ 'gallery.categoriesError' | translate }}
            </span>
          } @else {
            @for (cat of categories.value(); track $index) {
              <div
                class="font-bold p-2 hover:text-primary transition-[3s] cursor-pointer"
                [class.text-primary]="selectedCategory() == cat"
                (click)="selectCategory(cat)"
              >
                {{ cat.title }}
              </div>
            } @empty {
              <span class="text-xl text-neutral-500 text-center">
                {{ 'gallery.categoriesEmpty' | translate }}
              </span>
            }
          }
        }
      } @placeholder {
        <p-skeleton height="4.5rem" />
      }
    </div>
  </div>

  <div class="w-0.5 h-[95%] mt-auto mb-auto bg-neutral-950 desktop"></div>

  <div id="image-list" class="flex flex-col h-full flex-4 pl-4 pr-4 overflow-auto"
      [class.hide]="selectedCategory() == undefined">
    @if (selectedCategory()) {
      <div class="flex items-center">
        <p-button [rounded]="true" [text]="true" (onClick)="selectCategory(undefined)" class="mobile">
          <mat-icon color="white">arrow_back</mat-icon>
        </p-button>
        <h2 class="text-2xl font-bold">{{ selectedCategory().title }}</h2>
      </div>

      @if (selectedCategory().description) {
        <p class="whitespace-pre-wrap mt-4 border-l-2 border-neutral-600 pl-2">
          {{ selectedCategory().description }}
        </p>
      }

      @if ((images.hasValue() && images.value().length > 0) || !images.hasValue()) {
        <masonry
          class="mt-8"
          [images]="images.value()"
          [loading]="!images.hasValue()"
          [columnWidth]="400"
          (imageClicked)="openImageDetails($event)"
        >
        </masonry>
      } @else {
        <span class="text-xl text-neutral-500 text-center">
          {{ 'gallery.imagesEmpty' | translate }}
        </span>
      }
    }
  </div>
</div>
